import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserData, LoginAPI, ForgotPasswordAPI } from "../redux/Auth/actions";
import Loader from "../component/loader";
import Modal from "../component/modal";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    selectedRole: "Admin",
    showPassword: false,
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const userRole = [
    {
      name: "Admin",
      role: "Admin",
    },
    {
      name: "Manager",
      role: "Manager",
    },
    {
      name: "Store",
      role: "Store",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    if (name === "email") {
      if (!value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Email is required.",
        }));
      } else if (!/\S+@\S+\.\S+/.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Email is invalid.",
        }));
      }
    }

    if (name === "password" && !value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password is required.",
      }));
    }
  };

  const handleUser = (role) => {
    setFormData((prevData) => ({
      ...prevData,
      selectedRole: role,
    }));
  };

  const toggleShowPassword = () => {
    setFormData((prevData) => ({
      ...prevData,
      showPassword: !prevData.showPassword,
    }));
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = { email: "", password: "" };

    if (!formData.email) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
      valid = false;
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleAction = async () => {
    if (validateForm()) {
      setLoading(true);
      let obj = {
        email: formData.email,
        password: formData.password,
        role: formData.selectedRole,
      };
      await dispatch(LoginAPI(obj))
        .then((res) => {
          if (res?.status === 200) {
            localStorage.setItem("token", res?.data?.token);
            setLoading(false);
            getUserData(dispatch);
            if (formData.selectedRole === "Manager" || formData.selectedRole === "Admin") {
              navigate("/manager/transactions");
            } else if (formData.selectedRole === "Store") {
              navigate("/home/dashboard/sale");
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Login failed", error);
        });
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      alert("Please enter your email");
      return;
    }
    setForgotLoading(true);
    await dispatch(ForgotPasswordAPI({ email: forgotEmail }))
      .then((res) => {
        setForgotLoading(false);
        if (res?.status === 200) {
          setIsForgotModalOpen(false);
          setForgotEmail("");
        }
      })
      .catch((err) => {
        setForgotLoading(false);
        console.log("Forgot password error", err);
      });
  };

  return (
    <div className="flex bg-white">
      <div className="w-1/2 max-lg:w-0 ">
        <img
          className="w-full h-screen min-h-full object-cover max-lg:hidden"
          src="./images/loginImg.svg"
          alt=""
        />
      </div>
      <div className="w-1/2 max-lg:w-full max-xl:my-10 mx-auto px-5 lg:px-10 flex justify-center items-center">
        <div className="w-auto max-w-[496px]  flex flex-col max-2xl:gap-10 gap-14">
          <div className="flex flex-col max-2xl:gap-5 gap-10">
            <div className="flex flex-col gap-5 max-lg:gap-2 text-center">
              <h2 className="text-5xl max-sm:text-4xl font-semibold uppercase">
                Logo
              </h2>
              <p className="text-xl max-2xl:text-base font-normal">
                Start managing your store faster and better
              </p>
            </div>
            <div className="flex gap-4 max-sm:gap-2 justify-center  text-lg max-2xl:text-base max-sm:text-sm font-medium">
              {userRole?.map((user) => {
                return (
                  <div
                    key={user.role}
                    onClick={() => handleUser(user.role)}
                    className={`py-3.5 max-sm:py-2 px-7 max-sm:px-3 border rounded-xl flex gap-2 cursor-pointer ${
                      formData.selectedRole === user.role
                        ? "border-primary text-primary"
                        : "border-gray-400 text-gray-400"
                    }`}
                  >
                    <input
                      type="radio"
                      name="selectedRole"
                      id=""
                      checked={formData.selectedRole === user.role}
                      readOnly
                    />
                    <p>{user.name}</p>
                  </div>
                );
              })}
            </div>
            <div>
              <form
                className="flex flex-col max-2xl:gap-6 gap-12 text-xl max-2xl:text-lg max-sm:text-base"
                action=""
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="flex flex-col gap-5">
                  <div className="flex flex-col gap-2">
                    <label className="" htmlFor="email">
                      Email
                    </label>
                    <input
                      className="h-14 2xl:h-16 w-full pl-4 rounded-xl border  focus:outline-none"
                      type="email"
                      name="email"
                      placeholder="Enter Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <span className="text-red-500 text-base -mt-2">
                        {errors.email}
                      </span>
                    )}
                  </div>
                  <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-2 ">
                      <label htmlFor="password">Password</label>
                      <div className="flex gap-1 items-center px-4 rounded-xl border">
                        <input
                          className="h-14 2xl:h-16 w-full focus:outline-none"
                          type={formData.showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Enter Password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <div
                          className="cursor-pointer"
                          onClick={toggleShowPassword}
                        >
                          {formData.showPassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                      </div>
                      {errors.password && (
                        <span className="text-red-500 text-base -mt-2">
                          {errors.password}
                        </span>
                      )}
                    </div>
                    <p 
                      className="hover:underline w-fit cursor-pointer text-primary font-medium" 
                      onClick={() => setIsForgotModalOpen(true)}
                    >
                      Forgot password?
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 ">
                  <input
                    className="w-4 h-4 !rounded-2xl"
                    type="checkbox"
                    name=""
                    id=""
                  />
                  <p>Remember me</p>
                </div>
              </form>
            </div>
          </div>
          <div>
            <button
              disabled={loading}
              onClick={() => handleAction()}
              className="w-full h-14 max-sm:h-12 text-white bg-primary hover:bg-[#00292f] rounded-xl max-sm:text-base max-2xl:text-lg text-xl font-semibold flex items-center justify-center"
            >
              {loading && <Loader />} LOGIN
            </button>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isForgotModalOpen}
        closeModal={() => setIsForgotModalOpen(false)}
        title="Forgot Password"
        modalWidth="max-w-[500px]"
        loading={forgotLoading}
        btn2="Submit"
        btnClass="justify-center"
        handleBtn2={handleForgotPassword}
        modalContent={
          <div className="flex flex-col gap-4">
            <p className="text-gray-500 text-base">Please enter your email address to receive a password reset link.</p>
            <div className="flex flex-col gap-2">
              <label htmlFor="forgotEmail">Email address</label>
              <input
                className="h-12 w-full pl-4 rounded-xl border focus:outline-none"
                type="email"
                id="forgotEmail"
                placeholder="Enter Email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default Login;
